import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../Components/Loader/Loader";
import { BuildQuickActionByIdActionHandler } from "../../../Redux/Actions/user/BuildQuickActionDetailsById";
import RunQuickAction from "./RunQuickAction";
import CustomQuickActionRun from "./CustomQuickActionRun/CustomQuickActionRun";

const ParentRunQuickAction = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const [pageLoader, setPageLoader] = useState(false);

  const buildQuickActionDetaills = useSelector(
    (state) =>
      state?.build_Quick_Action_By_Id_data?.build_quick_action_by_id__data?.data
  );

  useEffect(() => {
    if (params?.id) {
      setPageLoader(true);
      dispatch(BuildQuickActionByIdActionHandler(params?.id));
    }
  }, []);

  useEffect(() => {
    if (buildQuickActionDetaills) {
      setPageLoader(false);
    }
  }, [buildQuickActionDetaills]);

  return (
    <>
      {pageLoader && <Loader />}
      {buildQuickActionDetaills?.custom_qa_v_id === null ||
      buildQuickActionDetaills?.custom_qa_v_id === undefined ? (
        <RunQuickAction />
      ) : (
        <CustomQuickActionRun />
      )}
    </>
  );
};

export default ParentRunQuickAction;
